import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/link-external/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/link-external/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/link-external/locales/fi/messages.mjs';
import { messages as daMessages} from '../src/raw/link-external/locales/da/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages, daMessages);


export class IconLinkExternal16 extends LitElement {
  render() {
      const title = i18n.t({ message: `Square with an upward arrow to the right`, id: 'icon.title.link-external', comment: 'Title for link external icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="16"height="16"fill="none"viewBox="0 0 16 16" part="w-icon-link-external-16-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 1 8 8m3.04-7H15v3.96M7 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9"></path></svg>`; }
}
if (!customElements.get('w-icon-link-external-16')) {
  customElements.define('w-icon-link-external-16', IconLinkExternal16);
}